import 'normalize.css';

import { PomodoroProvider } from '@ifood/pomodoro-components';
import React from 'react';
import { QueryClientProvider } from 'react-query';

import { QUERY_CLIENT } from '@constants/react-query';
import { SessionProvider } from 'modules/Session';

import GlobalStyle from './global-styles';

import('@ifood/pomodoro-fonts');

type PropTypes = {
  element: React.ReactNode;
};

export const wrapPageElement = ({ element }: PropTypes): JSX.Element => (
  <>
    <GlobalStyle />
    <PomodoroProvider>
      <QueryClientProvider client={QUERY_CLIENT}>
        <SessionProvider>{element}</SessionProvider>
      </QueryClientProvider>
    </PomodoroProvider>
  </>
);
